import { mapGetters, mapActions } from 'vuex'

import SheetWrapper from '@/components/SheetWrapper/index'
import InfoBadge from '@/components/InfoBadge/index'
import MainButton from '@/components/MainButton/index'
import Card from '@/components/Card/index'
import PlainTextField from '@/components/PlainTextField/index'
import ResponseDialog from '@/components/ResponseDialog/index'

import { formatTimestamp } from '@/utils/dateHelpers'
import { formatRank } from '@/utils/formatRank'

export default {
  name: 'predictions',
  components: {
    SheetWrapper,
    InfoBadge,
    MainButton,
    Card,
    PlainTextField,
    ResponseDialog
  },
  data: () => ({
    pointsBg: require('@/assets/points.svg'),
    totalPointsBg: require('@/assets/total-points.svg'),
    rankBg: require('@/assets/rank-ribbon.svg'),
    predictions: null,
    loading: false,
    predictionResponseDialog: false,
    predictionResponseDialogText: '',
    duration: null,
    durationInterval: null,
    lastWeekPoints: null,
    totalPoints: null,
    globalRanking: null,
    seasonStatusMessage: ''
  }),
  computed: {
    ...mapGetters('predictions', {
      fetchFixturesResponse: 'FIXTURES',
      savePredictionsResponse: 'SAVE_RESULTS_RESPONSE'
    }),
    nextWeekTitle() {
      return `${this.duration ? 'Next week ' : 'Current'} Predictions`
    },
    countdown() {
      return this.duration
        ? `Will close in ${this.duration.days()}d ${this.duration.hours()}hr ${this.duration.minutes()}m ${this.duration.seconds()}s`
        : `Prediction tipping is now closed.`
    }
  },
  methods: {
    ...mapActions('predictions', {
      fetchFixtures: 'FETCH_RESULTS',
      saveResultsAction: 'SAVE_RESULTS',
      fetchUserStatus: 'FETCH_USER_STATUS'
    }),
    bankered(state) {
      return state ? 'primary' : 'light'
    },
    toggleBanker(index) {
      this.predictions[index].banker = !this.predictions[index].banker
      this.$forceUpdate()
    },
    toggleBankerHandler(index) {
      const bankerCounter = this.predictions.filter(item => item.banker)
      if (bankerCounter.length < 3) {
        this.toggleBanker(index)
      } else if (bankerCounter.length === 3 && this.predictions[index].banker) {
        this.toggleBanker(index)
      } else {
        this.predictionResponseDialogText =
          'You can only have 3 bankers per round'
        this.predictionResponseDialog = true
      }
    },
    savePredictions() {
      this.saveResultsAction({
        results: this.predictions
      }).then(() => {
        this.predictionResponseDialogText = 'Successfully saved results'
        this.predictionResponseDialog = true
      })
    },
    predicted(value, index, key) {
      this.predictions[index][key].result = value || ''
      const predictionArray = this.$refs.prediction

      const predictionFocusedIndex = predictionArray.findIndex(
        item => item.$children[0].isFocused
      )
      const nextFieldIndex = predictionFocusedIndex + 1

      if (value && nextFieldIndex < predictionArray.length) {
        predictionArray[nextFieldIndex].$children[0].focus()
      }
    },
    formatDate(timestamp) {
      return formatTimestamp({ timestamp })
    },
    getFormeColor(forme) {
      return forme === 'W' ? 'primary' : forme === 'L' ? 'error' : 'light'
    },
    responseDialogButtonClick() {
      this.predictionResponseDialog = false
    },
    displayRank(rank) {
      return `${formatRank(rank)} Place`
    }
  },
  activated() {
    this.$store.commit('SET_PAGE_TITLE', 'run through')
    this.fetchFixtures().then(() => {
      const { data } = this.fetchFixturesResponse
      this.predictions = data
    })
  }
}
